import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Nav, NavItem, NavLink } from "react-bootstrap";
import { fetchKPIDashboardInputData } from "./../../../actions/closeLoop/kpiDashboard/dashboardActions";
import NavBar from "./../../automate_kpi_tja_v2/Topbar";
import PropTypes from "prop-types";
import classnames from "classnames";
import LandingScenario from "./LandingScenario";
// import KpiSummaryDashboardVersion2 from "../../automate_kpi_tja_v2/KpiSummaryDashboardVersion2";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import KpiSummaryMain from "../../automate_kpi_tja_v2/KpiSummaryDashboardEnhanced/KpiSummaryMain";
function KPIDashboard(props) {
  const [activeTabs, setActiveTab] = useState("1");
  // const [tabs, setTabs] = useState("0");
  function toggle(tab) {
    setActiveTab(tab);
  }

  useEffect(() => {
    props.getFilterDetails();
  }, []);

  console.log(props);
  console.log(activeTabs);
  return (
    <>
      <div>
        <NavBar />
        <Breadcrumb>
          <Breadcrumb.Item href="">
            <Link to="/navigate_new">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to="/welcomeautomatekpi">Automate KPI</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to="/welcomeautomatekpi/landingkpidashboard">
              KPI Dashboard
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to="/kpidashboardcloseloop">Close Loop</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/close_loop/individual/kpi/dashboard" active>
            {" "}
            AD Analytics
          </Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="nav nav-tabs"
          style={{
            marginLeft: "1%",
            marginRight: "1%",
            backgroundColor: "#CACED5",
          }}
        >
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTabs === "1" })}
                onClick={() => {
                  toggle("1");
                }}
                style={
                  activeTabs === "1"
                    ? { backgroundColor: "#B0ff44" }
                    : { cursor: "pointer", color: "#464646" }
                }
              >
                Kpi Detailed Dashboard
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink
                className={classnames({ active: activeTabs === "2" })}
                onClick={() => {
                  toggle("2");
                }}
                style={
                  activeTabs === "2"
                    ? { backgroundColor: "#B0ff44" }
                    : { cursor: "pointer", color: "#464646" }
                }
              >
                KPI Summary Dashboard version 2
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                className={classnames({ active: activeTabs === "3" })}
                onClick={() => {
                  toggle("2");
                }}
                style={
                  activeTabs === "2"
                    ? { backgroundColor: "#B0ff44" }
                    : { cursor: "pointer", color: "#464646" }
                }
              >
                KPI Summary Dashboard
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <div>
          {activeTabs === "1" ? <LandingScenario /> : null}
          {/* {activeTabs === "2" ? (
            <KpiSummaryDashboardVersion2 {...props} />
          ) : null} */}
          {activeTabs === '2' ? <KpiSummaryMain {...props} /> : null}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  filterDataLoading: state.dashboardFilterData.loading,
  filterDataError: state.dashboardFilterData.error,
  filterData: state.dashboardFilterData.info,
});

const mapDispatchToProps = (dispatch) => ({
  getFilterDetails: () => dispatch(fetchKPIDashboardInputData()),
});

KPIDashboard.propTypes = {
  filterDataLoading: PropTypes.bool,
  filterDataError: PropTypes.string,
  getFilterDetails: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps)(KPIDashboard);
